module.exports = __webpack_public_path__ + "static/fin1-6579d2dd8aa4433b7c0146461a3ab316.jpg";